import useFlag from 'hooks/useFlag'
import {
  usePermissionReason,
  useRbacNavDisabledWithReason,
} from 'hooks/useRbacNavCheck'
import { buildTranslate } from 'locales'
import React from 'react'
import { useAbility } from 'utilities/ability'
import NavLink from '../Bar/NavLink'

const t = buildTranslate('nav.feedback_menu')

type PropsT = {
  onClick?: () => void
  isLeftNav?: boolean
  isLegacy?: boolean
  // Legacy-only: opens the NPS→RecoveryAI transition modal instead of
  // navigating. Owned by the caller (OperationsCenter), which has the
  // RecoveryAI config needed to pick the modal variant.
  onNpsClick?: () => void
}

const FeedbackContent = ({
  isLeftNav = false,
  onClick = () => {},
  isLegacy = false,
  onNpsClick,
}: PropsT) => {
  const ability = useAbility()
  const rbacEnabled = useFlag('role-based-access-control', false)
  const feedback = useRbacNavDisabledWithReason('Feedback')

  // RBAC uses LocationReports; legacy uses NpsReports.
  // Tooltip (usePermissionReason) only resolves when RBAC is on, so
  // LocationReports is always the correct subject for the reason label.
  const overviewDisabled = rbacEnabled
    ? ability.cannot('access', 'LocationReports')
    : ability.cannot('access', 'NpsReports')
  const overviewReason = usePermissionReason(
    'LocationReports',
    overviewDisabled
  )

  const handleNpsClick = () => {
    onClick()
    onNpsClick?.()
  }

  // Only the legacy caller that supplies a handler trades navigation for the
  // modal; every other caller keeps its href-based link untouched.
  const opensNpsModal = isLegacy && !!onNpsClick

  return (
    <>
      <NavLink
        isLeftNav={isLeftNav}
        onClick={onClick}
        text={t('respond')}
        link="/responses"
        disabled={feedback.disabled}
        disabledReason={feedback.disabledReason}
        isLegacy={isLegacy}
      />
      {opensNpsModal ? (
        <NavLink
          isLeftNav={isLeftNav}
          onClick={handleNpsClick}
          text={t('nps')}
          disabled={overviewDisabled}
          disabledReason={overviewReason}
          isLegacy
        />
      ) : (
        <NavLink
          isLeftNav={isLeftNav}
          onClick={onClick}
          link="/reports/feedback"
          text={isLegacy ? t('nps') : t('overview')}
          disabled={overviewDisabled}
          disabledReason={overviewReason}
          isLegacy={isLegacy}
        />
      )}
    </>
  )
}

export default FeedbackContent
